export const webEndpoints = {
  index: {
    path: '/',
    to: () => '/' as const,
  },
  auth: {
    path: '/auth',
    to: () => '/auth' as const,
  },
  computers: {
    path: '/computers',
    to: () => '/computers' as const,
  },
  scheduledTasks: {
    path: '/scheduled-tasks',
    to: () => '/scheduled-tasks' as const,
  },
  serverById: {
    path: '/servers/:id',
    to: (serverId: string) => `/servers/${serverId}` as const,
  },
  addExternalServer: {
    path: '/add-external-server',
    to: () => '/add-external-server' as const,
  },
  addInternalServer: {
    path: '/add-internal-server',
    to: () => '/add-internal-server' as const,
  },
  admin: {
    path: '/admin',
    to: () => '/admin' as const,
  },
  subscription: {
    path: '/subscription',
    to: () => '/subscription' as const,
  },
  chatById: {
    path: '/c/:chatId',
    to: (chatId: string) => `/c/${chatId}` as const,
  },
} as const;
